import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import useModuleAuth from '../../hooks/useModuleAuth';

const items = [
  { label: 'Customers list', to: '/customers' },
  { label: 'Reviews & Ratings', to: '/reviews' },
  { label: 'Support tickets', to: '/tickets' },
];

const CustomersLayout = () => {
  const navigate = useNavigate();
  const { user, role, logout } = useModuleAuth();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <div className="flex min-h-screen">
        <aside className="hidden w-72 shrink-0 border-r border-slate-200 bg-slate-950 text-slate-100 lg:block">
          <div className="px-5 py-6 border-b border-slate-900">
            <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Homevilas</p>
            <p className="text-sm font-semibold">Customers</p>
          </div>
          <div className="px-4 py-6 space-y-2">
            {items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  [
                    'flex items-center gap-3 rounded-lg border px-3 py-2 text-sm font-medium transition',
                    isActive
                      ? 'border-emerald-400/40 bg-emerald-500/15 text-emerald-100'
                      : 'border-transparent text-slate-200 hover:bg-slate-800',
                  ].join(' ')
                }
              >
                <span className="h-2 w-2 rounded-full bg-current" />
                {item.label}
              </NavLink>
            ))}
          </div>
        </aside>

        <main className="flex-1">
          <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-slate-200 bg-white px-4 sm:px-6">
            <div>
              <p className="text-xs uppercase tracking-wide text-emerald-700">Homevilas</p>
              <p className="text-sm font-semibold text-slate-900">Customers workspace</p>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <div className="text-right">
                <p className="text-sm font-semibold text-slate-900">{user?.email || 'User'}</p>
                <p className="text-xs text-slate-500">{role || 'STAFF'}</p>
              </div>
              <button
                type="button"
                onClick={() => {
                  logout();
                  navigate('/login');
                }}
                className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              >
                Logout
              </button>
            </div>
          </header>
          <div className="border-b border-slate-200 bg-white px-4 py-2 lg:hidden">
            <div className="flex gap-2 overflow-x-auto">
              {items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    [
                      'whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold',
                      isActive ? 'bg-emerald-100 text-emerald-700' : 'text-slate-600',
                    ].join(' ')
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
          <div className="p-4 sm:p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default CustomersLayout;
